import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "right_cont" }

import { getGroupsByDeptCodes } from '@/config/request';
import { reactive, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'reservation-list',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const themeId = route.query.themeId
const typeName = route.query.typeName
const newsList = ref([]) as any
const pagination = reactive({
    pageNo: 1,
    pageSize: 10,
})


const getNewsList = async() => {
    let param = {
      deptCode:"M001" //预约系统部门id
    }
    console.log('param',param);

    const res = await getGroupsByDeptCodes(param) as any
    newsList.value = res.result.attachObjectEx

}

const showDetail = (item:any) => {
    router.push({
        path: '/do-things-online/reservation-detail',
        query:{
          dept_code: item.dept_code,
          name: item.name,
          waiting_count: item.waiting_count,
          wait_timeout_minute: item.wait_timeout_minute,
          average_service_minute: item.average_service_minute,
          code: item.code,
        }
    })
}
const handleCurrentChange = (index:any) => {
    pagination.pageNo = index
    getNewsList()
}
getNewsList()

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createElementVNode("span", null, "网上办事"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createElementVNode("span", null, "在线预约")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_table, {
              data: newsList.value,
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "100",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "窗口名称",
                  width: "500"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "wait_timeout_minute",
                  label: "等待时间（分钟）",
                  width: "200",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "waiting_count",
                  label: "等待人数",
                  width: "200",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "200",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: ($event: any) => (showDetail(scope.row))
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("预约", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})